.marker {
  position: absolute;
  inset: 0;
  pointer-events: none;
  color: var(--zumpo-green);
}

.mine {
  color: var(--zumpo-danger);
}

.auto {
  color: var(--zumpo-muted);
}

/* The ring is an SVG so the Auto dashes follow Figma's 4 / 3 rhythm. The
   SVG covers the cell exactly, since Chrome snaps an SVG box at a half pixel,
   and the rect sits half a stroke inside it, so the centred stroke lies just
   inside the cell's edge like Figma's inside stroke. */
.ring {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.ring rect {
  x: 1.5px;
  y: 1.5px;
  width: calc(100% - 3px);
  height: calc(100% - 3px);
}

.compact .ring rect {
  x: 1px;
  y: 1px;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
}

.badge {
  position: absolute;
  top: -6px;
  right: 1px;
  display: flex;
  padding: var(--zumpo-space-1) var(--zumpo-space-4);
  border-radius: var(--zumpo-radius-999);
  background: currentColor;
}

.compact .badge {
  right: -3px;
}

.initials {
  color: var(--zumpo-paper);
  font: 500 10px / 12px var(--zumpo-font-dm-sans);
  white-space: nowrap;
}

.compact .initials {
  font-size: 8px;
  line-height: 10px;
}
